import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Cart from './pages/Cart';
import Favorites from './pages/Favorites';
import Product from './pages/Product';
import Infos from './pages/Infos';
import Purchase from './pages/Purchase';
import Search from './pages/Search';
import Orders from './pages/Orders';
import Payment from './pages/Payment';
import OrdersforAdmin from './pages/OrdersforAdmin';
import CategoriesforAdmin from './pages/CategoriesforAdmin';
import ProductsforAdmin from './pages/ProductsforAdmin';
import ReportsforAdmin from './pages/ReportsforAdmin';
import ImagesforAdmin from './pages/ImagesforAdmin';
import Dashboard from './pages/admin/Dashboard';
import Integrations from './pages/admin/Integrations';
import Communications from './pages/admin/Communications';
import StyleGuide from './pages/StyleGuide';
import { About, Contact, Faqs, Policy, NotFound } from './pages/InfoPages';
import ShopOverlays from './components/ShopOverlays';
import { useUserContext } from './contexts/UserContext';
import useGetUserRole from './hooks/useGetUserRole';

const App = () => {

  const { currentUser } = useUserContext();
  const [admin, checkingRole] = useGetUserRole(currentUser);
  const { pathname } = useLocation();
  const isAdminPage = pathname.startsWith('/admin');

  // New page → start at the top (browsers keep the old scroll position in single-page apps)
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <>
      {/* Admin pages bring their own shell (AdminLayout) */}
      {!isAdminPage && <Navbar />}
      {/* Room for the fixed phone tab bar on storefront pages */}
      <Box pb={{ base: isAdminPage ? 0 : '64px', md: 0 }} >
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/favorites' element={<Favorites />} />
        <Route path='/product' element={<Product />} />
        <Route path='/product/:id' element={<Product />} />
        <Route path='/infos' element={currentUser ? <Infos /> : <Navigate to='/' />} />
        <Route path='/orders' element={currentUser ? <Orders /> : <Navigate to='/' />} />
        <Route path='/purchase' element={<Purchase />} />
        <Route path='/search' element={<Search />} />
        <Route path='/payment' element={<Payment />} />
        <Route path='/pages/about' element={<About />} />
        <Route path='/pages/contact' element={<Contact />} />
        <Route path='/pages/faqs' element={<Faqs />} />
        <Route path='/policies/:slug' element={<Policy />} />
        {process.env.NODE_ENV !== 'production' && <Route path='/styleguide' element={<StyleGuide />} />}
        {
            admin
            ?
            <>
              <Route path='/admin' element={<Dashboard />} />
              <Route path='/admin/products' element={<ProductsforAdmin />} />
              <Route path='/admin/categories' element={<CategoriesforAdmin />} />
              <Route path='/admin/orders' element={<OrdersforAdmin />} />
              <Route path='/admin/images' element={<ImagesforAdmin />} />
              <Route path='/admin/reports' element={<ReportsforAdmin />} />
              <Route path='/admin/integrations' element={<Integrations />} />
              <Route path='/admin/communications' element={<Communications />} />
            </>
            :
            <Route path='/admin/*' element={checkingRole ? null : <Navigate to='/' />} />
        }
        <Route path='*' element={<NotFound />} />
      </Routes>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <ShopOverlays />}
      </Box>
    </>
  )
}

export default App;